export const SEND_TOAST = 'SEND_TOAST';

export const TOAST_REQUEST = 'TOAST_REQUEST';
export const TOAST_SUCCESS = 'TOAST_SUCCESS';
export const TOAST_FAILURE = 'TOAST_FAILURE';
